module.exports = __webpack_public_path__ + "img/svgArrow3.6efcf024.svg";